import type { Project, ProjectUpsertPayload } from '../services/commercialProjectsApi';

export const PROJECT_STATUS_LABELS: Record<string, string> = {
  Draft: 'Rascunho',
  Active: 'Ativo',
  OnHold: 'Em espera',
  Completed: 'Concluído',
  Cancelled: 'Cancelado',
};

export function toDateInput(value?: string | null): string {
  return value ? value.slice(0, 10) : '';
}

export function emptyProjectForm(contractId: string): ProjectUpsertPayload {
  return {
    contractId,
    code: '',
    name: '',
    status: 'Draft',
    lifecycleModel: 'Hybrid',
    stakeholderCommitmentObtained: false,
  };
}

export function projectToForm(project: Project): ProjectUpsertPayload {
  return {
    contractId: project.contractId,
    code: project.code,
    name: project.name,
    description: project.description ?? '',
    status: project.status,
    scopeStatement: project.scopeStatement ?? '',
    workProducts: project.workProducts ?? '',
    sizeEstimate: project.sizeEstimate,
    sizeUnit: project.sizeUnit ?? '',
    lifecycleModel: project.lifecycleModel,
    lifecyclePhases: project.lifecyclePhases ?? '',
    effortEstimateHours: project.effortEstimateHours,
    costEstimate: project.costEstimate,
    budgetAmount: project.budgetAmount,
    scheduleNotes: project.scheduleNotes ?? '',
    plannedStartDateUtc: toDateInput(project.plannedStartDateUtc),
    plannedEndDateUtc: toDateInput(project.plannedEndDateUtc),
    baselineStartDateUtc: toDateInput(project.baselineStartDateUtc),
    baselineEndDateUtc: toDateInput(project.baselineEndDateUtc),
    actualStartDateUtc: toDateInput(project.actualStartDateUtc),
    actualEndDateUtc: toDateInput(project.actualEndDateUtc),
    resourcesPlan: project.resourcesPlan ?? '',
    infrastructureNotes: project.infrastructureNotes ?? '',
    feasibilityAssessment: project.feasibilityAssessment ?? '',
    stakeholderCommitmentObtained: project.stakeholderCommitmentObtained,
    stakeholderCommitmentAtUtc: toDateInput(project.stakeholderCommitmentAtUtc),
    monitoringNotes: project.monitoringNotes ?? '',
    actualEffortHours: project.actualEffortHours,
    actualCost: project.actualCost,
    ownerUserId: project.ownerUserId,
    notes: project.notes ?? '',
  };
}

export function normalizeProjectPayload(form: ProjectUpsertPayload, contractId: string): ProjectUpsertPayload {
  return {
    ...form,
    contractId,
    plannedStartDateUtc: form.plannedStartDateUtc || null,
    plannedEndDateUtc: form.plannedEndDateUtc || null,
    baselineStartDateUtc: form.baselineStartDateUtc || null,
    baselineEndDateUtc: form.baselineEndDateUtc || null,
    actualStartDateUtc: form.actualStartDateUtc || null,
    actualEndDateUtc: form.actualEndDateUtc || null,
    stakeholderCommitmentAtUtc: form.stakeholderCommitmentAtUtc || null,
  };
}

export function formatProjectDate(value?: string | null): string {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('pt-BR');
}
